import AspectRatioIcon from '@mui/icons-material/AspectRatio'
import FitScreenIcon from '@mui/icons-material/FitScreen'
import { Button, styled } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import { useParams } from 'react-router-dom'
import useGallerySettings from '../../../account/views/gallery/hooks/useGallerySettings'
import useBucketGallerySettings from '../../hooks/useBucketGallerySettings'

const MenuButton = styled(Button)(({ theme }) => ({
  padding: '2px',
  minWidth: 'auto',
  borderRadius: '50%',
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main
})) as typeof Button

interface CropModeSwitchProps {
  hidden?: boolean
}

export default function CropModeSwitch({ hidden }: CropModeSwitchProps) {
  const { userId } = useParams<{ userId: string }>()
  const { settings, updateSettings } = useBucketGallerySettings()
  const { settings: gallerySettings, saveGallerySettings } = useGallerySettings()
  const cropMode = userId ? gallerySettings.cropMode ?? true : settings.cropMode ?? true

  const handleClick = () => {
    // if userId is present, legacy shared media
    if (userId) {
      saveGallerySettings({ ...gallerySettings, cropMode: !cropMode })
    } else {
      updateSettings({ cropMode: !cropMode }, { skipMutation: true })
    }
  }

  if (hidden) {
    return null
  }

  return (
    <Tooltip title={`Crop Mode: ${cropMode ? 'Original' : 'Boxed'}`} arrow>
      {cropMode ? (
        <MenuButton
          onClick={handleClick}
          sx={{ border: '1px solid', borderColor: 'primary.main', borderRadius: '50%', color: 'primary.main' }}
          data-test="crop-mode-original"
        >
          <FitScreenIcon sx={{ padding: '1px' }} />
        </MenuButton>
      ) : (
        <MenuButton
          onClick={handleClick}
          sx={{ border: '1px solid', borderColor: 'primary.main', borderRadius: '50%', color: 'primary.main' }}
          data-test="crop-mode-boxed"
        >
          <AspectRatioIcon sx={{ padding: '2px' }} />
        </MenuButton>
      )}
    </Tooltip>
  )
}

CropModeSwitch.defaultProps = {
  hidden: false
}
